import * as React from 'react';
import Weighbridge from "./Weighbridge";

const Kiosk = () => {
    React.useEffect(() => {
//        require('./kiosk.scss');
    }, []);
    return (<Weighbridge />);
}

export default Kiosk;